const MS_PER_SECOND = 1000

export const isTimeInTheFuture = (timeInSeconds: number) => {
  const currentTimeInSeconds = Math.floor(new Date().getTime() / MS_PER_SECOND)

  return currentTimeInSeconds < timeInSeconds
}

export const isDateInTheFuture = (date: string | undefined | null) => {
  if (!date) return undefined

  const dateInSeconds = Math.floor(Date.parse(date) / MS_PER_SECOND)

  if (Number.isNaN(dateInSeconds)) return undefined

  return isTimeInTheFuture(dateInSeconds)
}
